import React, { useEffect, useContext, useState } from 'react';
import { withRouter, Switch, Route } from 'react-router-dom';
import { path, defaultTo } from 'ramda';
import { AuthContext } from './_context';
import storage from 'local-storage-fallback';
import styled from 'styled-components';
//import Encuesta from './_pages/Encuesta';
//import Fixture from './_pages/Fixture';
//import VideoLanding from './_pages/VideoLanding';
//import SecurityDay from './_pages/SecurityDay';
//import ChallengeBox from './_pages/ChallengeBox';
//import IncentivoTiendas from './_pages/IncentivoTiendas';
//import IncentivoAutitos from './_pages/IncentivoAutitos';
//import IncentivoAutitosFerrari from './_pages/IncentivoAutitosFerrari';
//import IncentivoAutitosStarWars from './_pages/IncentivoAutitosStarWars';
// import IncentivoMundial from './_pages/IncentivoMundial';
// import IncentivoCoca from './_pages/IncentivoCoca';
import ListaMundial from './_pages/ListaMundial';
//import IncentivoToyStory from './_pages/IncentivoToyStory';
import IncentivoCompetenciaShellBox from './_pages/IncentivoCompetenciaShellBox';

import Login from './_pages/Login';
//import CompetenciaShellBox from './_pages/CompetenciaShellBox';
//import { PopProfile } from '~/_components';
//import Contact from './pages/Contact';
//import ForgotPassword from './pages/ForgotPassword';
//import { LINKS } from './constants';
import Routes from './_Routes';
import TermsContainer from '../src/_components/Maintenance/TermsContainer'

// isAuth should be false, otherwise (if it's falsy but null or undefined) it means that it wasn't yet determined
const haveToken = defaultTo('', storage.getItem('protagonistas_token'));
const isNotAuth = authContext => path(['isAuth'], authContext) === false;
//const allowedRoutes = [LINKS.CONTACT, '/forgot-password'];
//const allowedRoutes = ['/encuesta'];
//const allowedRoutes = ['/qatar2022'];
//const allowedRoutes = ['/challengebox', '/dia-de-la-seguridad', '/video-landing'];
//const allowedRoutes = ['/triplica-box'];
//const allowedRoutes = ['', 'trivia', 'campus', 'biblioteca', 'catalogo', 'perfil', 'semana-de-la-seguridad', 'baristas', "incentivo-tiendas", "incentivo-autitos-starwars", 'promo-jeep'];//, 'mas-power-que-nunca', "incentivo-autitos-ferrari"
//const allowedOfflineRoutes = ['promo-jeep', 'incentivo-autitos-starwars'];//'mas-power-que-nunca', 'semana-de-la-seguridad', 'incentivo-autitos', "incentivo-autitos-ferrari"
const allowedRoutes = ['', 'trivia', 'campus', 'biblioteca', 'catalogo', 'perfil', 'lista-mundial', 'competencia-shellbox', 'baristas'];//, 'promo-toystory', 'promo-cocacola','mas-power-que-nunca', "incentivo-autitos-ferrari", 'semana-de-la-seguridad', 'baristas', "incentivo-tiendas", "incentivo-autitos-starwars", 'promo-jeep', 'incentivo-mundial-2026'
const allowedOfflineRoutes = ['lista-mundial', 'competencia-shellbox'];//,'promo-toystory', 'promo-cocacola', 'mas-power-que-nunca', 'semana-de-la-seguridad', 'incentivo-autitos', "incentivo-autitos-ferrari",'promo-jeep', 'incentivo-autitos-starwars', 'incentivo-mundial-2026', 
//const disabledRoutes = ['mas-power-que-nunca'];

const Wrapper = styled.div`
  display: flex;
  width: 100%;
  min-height: 100%;
  >div{
    width: 100%;
  }
`

const Auth = ({ history }) => {

  const authContext = useContext(AuthContext);
  const [ isTttcAgree, setIsTttcAgree ] = useState(null);
  const [ openAppPop, setOpenAppPop ] = useState(true);

  useEffect(() => {
    /*
    if(!authContext.isAuth && !defaultTo('', storage.getItem('protagonistas_token')).length){
      if(!allowedRoutes.includes(path(['location', 'pathname'], history))){
        history.push('/');
      }
    }
    */

    let splited_history = (history?.location?.pathname?.split('/'))[1];

    if(defaultTo('', storage.getItem('protagonistas_token')).length){ //authContext.isAuth && 
      if(!allowedRoutes.includes(splited_history)){
        history.push('/');
      }

    }else{
      if(!allowedOfflineRoutes.includes(splited_history)){
        history.push('/');
      }
      /*
      if(!allowedOfflineRoutes.includes(splited_history)){
        console.log("2")

        if(disabledRoutes.includes(splited_history)){
          console.log("1n")
          history.push('/');
        }

        if(authContext.isAuth !== null && authContext.isAuth === false){
          console.log("3")
          history.push('/');
        }
      }else{
        console.log("4");
        history.push('/');
      }
      */

    }

    

    //if (isNotAuth(authContext) && !allowedRoutes.includes(path(['location', 'pathname'], history))) history.push('/');
  }, [authContext, history]);

  
  //console.log("history ->", splited_history)
  useEffect(() => {
    //console.log("isNotAuth", authContext.isAuth)

    return () => {}
  }, [isNotAuth])


  return (
    <Wrapper>
      {/* {(authContext.isAuth && openAppPop) ? 
        <PopProfile setOpenAppPop={setOpenAppPop} />
      : ""} */}
      {authContext.isLoading && (
        <div className="spinner-wrapper">
          <div className="spinner-loader" />
        </div>
      )}
      {
        authContext.isAuth ?
        authContext.tttcAgree ?
          <Routes />
        : <TermsContainer />
        : <></>
      }
      {!authContext.isAuth /*isNotAuth(authContext)*/ && (

        <Switch>
          {/* <Route path="/mas-power-que-nunca" exact component={CompetenciaShellBox} /> */}
          {/* <Route path="/semana-de-la-seguridad" exact component={SecurityDay} /> */}
          {/* <Route path="/incentivo-autitos" exact component={IncentivoAutitos} /> */}
          {/* <Route path="/incentivo-autitos-ferrari" exact component={IncentivoAutitosFerrari} /> */}
          {/* <Route path="/incentivo-autitos-starwars" exact component={IncentivoAutitosStarWars} /> */}
          {/* <Route path="/incentivo-mundial-2026" exact component={IncentivoMundial} /> */}
          <Route path="/lista-mundial" exact component={ListaMundial} />
          {/* <Route path="/promo-cocacola" exact component={IncentivoCoca} /> */}
          {/* <Route path="/promo-toystory" exact component={IncentivoToyStory} /> */}
          <Route path="/competencia-shellbox" exact component={IncentivoCompetenciaShellBox} />
          {/*
          <Route path="/triplica-box" exact component={IncentivoTiendas} />
          
          <Route path="/contacto" exact component={Contact} />
          <Route path="/forgot-password" exact component={ForgotPassword} />
          <Route path="/encuesta" exact component={Encuesta} />
          <Route path="/qatar2022" exact component={Fixture} />
          
          <Route path="/video-landing" exact component={VideoLanding} />
          
          <Route path="/challengebox" exact component={ChallengeBox} />
          */}


          <Route path="/" exact component={Login} />
        </Switch>
      )}

    </Wrapper>
  );
};

export default withRouter(Auth);
